const en_purch_returnsupplier = {
    "": "supplier return",
    type: "return method",

    label: {
        ref_itemin: "goods receipt reference",
        no_trans_in: "goods receipt transaction number",
    },

    error: {
        create: "Failed to create supplier return.",
        edit: "Failed to update supplier return.",
        type: "Return type cannot be empty.",
        sn_not_found: "Item with serial number {{sn}} is still in the warehouse or not yet registered.",
    },

    success: {
        create: "Supplier return created successfully.",
        edit: "Supplier return updated successfully.",
    },
}

export default en_purch_returnsupplier;